import {
  AreaChartOutlined,
  ClusterOutlined,
  DashboardOutlined,
  FormOutlined,
  LineChartOutlined,
  OrderedListOutlined,
  ScheduleOutlined,
  ShopOutlined,
  SolutionOutlined,
} from '@ant-design/icons';
import React, { lazy } from 'react';
import { PermissionNames } from '~/constants/permissionNames';
import store from '~/store';
import { actions } from '~/store/modules';
import { deleteTab } from '~/store/modules/tabs/actions';
import GFP from '../organisms/GFP';
import ExpeditionReport from '../pages/RfidReports/ExpeditionReport';
import Inventory from '../pages/RfidReports/Inventory';
import Movement from '../pages/RfidReports/Movement';
import Receipt from '../pages/RfidReports/Receipt';
import SalesStatementByType from '../pages/SalesStatementByType';

const Property = lazy(() => import('~/components/pages/Property'));
const ProductionPlanning = lazy(() => import('../templates/ProductionPlanning'));
const Packing = lazy(() => import('../pages/Packing'));
const CompetenceRegistration = lazy(() => import('../pages/CompetenceRegistration'));
const Dashboard = lazy(() => import('~/components/pages/Dashboard'));
const VouchersRegistration = lazy(() => import('../pages/VouchersRegistration'));
const VolLkp = lazy(() => import('../pages/VolLkp'));
const SalesReport = lazy(() => import('../pages/SalesReport'));
const SalesReportEcommerce = lazy(() => import('../pages/SalesReportEcommerce'));
const ProducerPageManagement = lazy(() => import('../pages/ProducerManagement/index'));
const Stock = lazy(() => import('../templates/Stock'));
const Expedition = lazy(() => import('../templates/Expedition'));
const RegisterAnnoucement = lazy(() => import('../pages/RegisterAnnouncement/index'));
const AnnouncementReport = lazy(() => import('../pages/AnnouncementReports'));
const PLP = lazy(() => import('../templates/PLP'));
const Preferences = lazy(() => import('../templates/Preferences'));
const ShippingCompany = lazy(() => import('../templates/ShippingCompany'));
const AutoService = lazy(() => import('../templates/AutoService'));
const Announcements = lazy(() => import('../pages/Announcements'));
const Orders = lazy(() => import('../templates/Orders'));
const OrdersGfp = lazy(() => import('../templates/OrdersGfp'));
const OrdersToCollect = lazy(() => import('../pages/OrdersToCollect'));
const TagPrintingList = lazy(() => import('../organisms/TagPrintingList'));
const TechnicalSpecification = lazy(() => import('../templates/TechnicalSpecification'));
const ProductBarCode = lazy(() => import('../organisms/ProductBarCode'));
const PriceReport = lazy(() => import('~/components/pages/PriceReport/PriceReport'));
const KlokDrawReport = lazy(() => import('~/components/pages/KlokDrawReport/KlokDrawReport'));
const KlokStockReport = lazy(() => import('~/components/pages/KlokStockReport'));
const ManageSiteDecorator = lazy(() => import('~/components/pages/ManageSiteDecorator'));
const ProductRegistrationRequest = lazy(
  () => import('~/components/pages/ProductRegistrationRequest'),
);
const TagCart = lazy(() => import('~/components/pages/TagCart'));
const AcceptanceTerms = lazy(() => import('~/components/pages/AcceptanceTerms'));
const Authorization = lazy(() => import('~/components/pages/Authorization'));
const ProductCatalog = lazy(() => import('~/components/pages/ProductCatalog'));
const CustomerCatalog = lazy(() => import('~/components/pages/CustomerCatalog'));
const Agreements = lazy(() => import('~/components/pages/Agreements'));
const WithheldGfp = lazy(() => import('~/components/pages/WithheldGfp'));
const GfpBatch = lazy(() => import('~/components/pages/GfpBatch'));
const KlokReservation = lazy(() => import('~/components/pages/KlokReservation'));
const SalesStatement = lazy(() => import('~/components/pages/SalesStatement'));
const ExpeditionManagement = lazy(() => import('~/components/pages/ExpeditionManagement'));
const GfpPrintingExpedition = lazy(() => import('~/components/pages/GfpPrintingExpedition'));
const OrderBarCode = lazy(() => import('~/components/pages/OrderBarCode'));

export type MenuType = {
  key: string;
  icon?: React.ReactNode;
  title: string;
  permissionName?: string;
  MenuItems?: MenuType[];
  component?: any;
  onCloseAction?: () => void;
  name?: any;
  cantClose?: boolean;
};

export const menus: MenuType[] = [
  {
    key: 'dashboard',
    icon: <DashboardOutlined />,
    title: 'Dashboard',
    name: 'Dashboard',
    permissionName: PermissionNames.MenuDashboard,
    component: () => <Dashboard />,
  },
  {
    key: 'registers',
    icon: <FormOutlined />,
    title: 'Cadastros',
    permissionName: PermissionNames.Registers.MenuRegisters,
    MenuItems: [
      {
        key: 'propriedade',
        name: 'Cadastro de Propriedade',
        component: () => <Property />,
        title: 'Cadastro de Propriedade',
        permissionName: PermissionNames.Registers.MenuProperty,
      },
      {
        key: 'planejamento-producao',
        name: 'Planejamento de Produção',
        component: () => <ProductionPlanning />,
        title: 'Planejamento de Produção',
        permissionName: PermissionNames.Registers.MenuProductionPlanning,
      },
      {
        key: 'packing',
        name: 'Cadastro de Embalagens',
        component: () => <Packing />,
        title: 'Cadastro de Embalagens',
        permissionName: PermissionNames.Registers.MenuPacking,
      },
      {
        key: 'productorPreferences',
        name: 'Preferências do Produtor',
        component: () => <Preferences />,
        title: 'Preferências do Produtor',
        permissionName: PermissionNames.Registers.MenuProductorPreferences,
      },
      {
        key: 'stock',
        name: 'Estoque',
        component: () => <Stock />,
        title: 'Estoque',
        permissionName: PermissionNames.Registers.MenuStock,
      },
      {
        key: 'expedition',
        name: 'Cadastro de Expedição',
        component: () => <Expedition />,
        title: 'Cadastro de Expedição',
        permissionName: PermissionNames.Registers.MenuExpedition,
      },
      {
        key: 'shippingCompany',
        name: 'Transportadora',
        component: () => <ShippingCompany />,
        title: 'Transportadora',
        permissionName: PermissionNames.Registers.MenuShippingCompany,
      },
      {
        key: 'decorators',
        name: 'Gerenciar Decoradores',
        component: () => <ManageSiteDecorator />,
        title: 'Gerenciar Decoradores',
        permissionName: PermissionNames.Registers.MenuSiteDecorators,
      },
      {
        key: 'plp',
        name: 'Administrar PLP',
        component: () => <PLP />,
        title: 'Administrar PLP',
        permissionName: PermissionNames.Registers.MenuPLP,
      },
      {
        key: 'ProductRegistrationRequest',
        name: 'Gerenciar Produtos',
        component: () => <ProductRegistrationRequest />,
        title: 'Gerenciar Produtos',
        permissionName: PermissionNames.Registers.MenuProductRegistrationRequest,
      },
    ],
  },
  {
    key: 'commercial',
    icon: <ShopOutlined />,
    title: 'Gestão Comercial',
    permissionName: PermissionNames.Commercial.MenuCommercial,
    MenuItems: [
      {
        key: 'autoservice',
        name: 'Pedidos',
        component: () => <AutoService />,
        title: 'Pedidos',
        permissionName: PermissionNames.Commercial.MenuAutoservice,
      },
    ],
  },
  {
    key: 'announcements',
    icon: <OrderedListOutlined />,
    name: 'Comunicados',
    title: 'Comunicados',
    permissionName: PermissionNames.Announcements.MenuAnnouncements,
    MenuItems: [
      {
        key: 'announcementsList',
        name: 'Lista de Comunicados',
        title: 'Lista de Comunicados',
        permissionName: PermissionNames.Announcements.MenuAnnouncementsList,
        component: () => <Announcements />,
      },
    ],
  },
  {
    key: 'quality',
    icon: <ScheduleOutlined />,
    title: 'Qualidade',
    permissionName: PermissionNames.Quality.MenuQuality,
    MenuItems: [
      {
        key: 'technicalSpecification',
        name: 'Especificação Técnica',
        component: () => <TechnicalSpecification />,
        title: 'Especificação Técnica',
        permissionName: PermissionNames.Quality.MenuTechnicalSpecification,
      },
      {
        key: 'productBarCode',
        name: 'Impressão Código de Barras Produtor',
        component: () => <ProductBarCode />,
        title: 'Impressão Código de Barras Produtor',
        permissionName: PermissionNames.Quality.MenuProductBarCode,
      },
      {
        key: 'orderBarCode',
        name: 'Pedido Código de Barras',
        component: () => <OrderBarCode />,
        title: 'Pedido Código de Barras',
        permissionName: PermissionNames.Quality.MenuOrderBarCode,
      },
    ],
  },
  {
    key: 'qualityManager',
    icon: <ScheduleOutlined />,
    title: 'Gestão de qualidade',
    permissionName: PermissionNames.QualityManager.MenuQuality,
    MenuItems: [
      {
        key: 'competence',
        name: 'Cadastro de Competência',
        component: () => <CompetenceRegistration />,
        title: 'Cadastro de Competência',
        permissionName: PermissionNames.QualityManager.MenuCompetence,
      },
    ],
  },
  {
    key: 'gfp',
    icon: <ScheduleOutlined />,
    title: 'GFP',
    permissionName: PermissionNames.Gfp.MenuGFP,
    MenuItems: [
      {
        key: 'gfp2',
        name: 'GFP',
        component: () => <GFP />,
        title: 'GFP',
        permissionName: PermissionNames.Gfp.MenuGFP2,
      },
      {
        key: 'acceptanceTerms',
        name: 'Termos de Aceite Eletrônico',
        component: () => <AcceptanceTerms />,
        title: 'Termos de Aceite Eletrônico',
        permissionName: PermissionNames.Gfp.MenuAcceptanceTerms,
      },
      {
        key: 'tagCart',
        name: 'Montar Carrinhos',
        component: () => <TagCart />,
        title: 'Montar Carrinhos',
        permissionName: PermissionNames.Gfp.MenuTagCart,
      },
      {
        key: 'authorization',
        name: 'Credenciamento',
        component: () => <Authorization />,
        title: 'Credenciamento',
        permissionName: PermissionNames.Gfp.MenuAuthorization,
      },
      {
        key: 'withheld-gfp',
        name: 'GFP Retida',
        component: () => <WithheldGfp />,
        title: 'GFP Retida',
        permissionName: PermissionNames.Gfp.MenuWithheldGfp,
      },
      {
        key: 'gfpBatch',
        name: 'GFP Grupo/Produto',
        component: () => <GfpBatch />,
        title: 'GFP Grupo/Produto',
        permissionName: PermissionNames.Gfp.MenuGfpBatch,
      },
      {
        key: 'expeditionManagement',
        name: 'Gerenciamento por Expedição',
        component: () => <ExpeditionManagement />,
        title: 'Gerenciamento por Expedição',
        permissionName: PermissionNames.Gfp.MenuExpeditionManagement,
      },
      {
        key: 'gfpPrintingExpedition',
        name: 'Impressão de GFP por Expedição',
        component: () => <GfpPrintingExpedition />,
        title: 'Impressão de GFP por Expedição',
        permissionName: PermissionNames.Gfp.MenuGfpPrintingExpedition,
      },
    ],
  },
  {
    key: 'offers',
    icon: <OrderedListOutlined />,
    title: 'Ofertas',
    permissionName: PermissionNames.Offers.MenuOffers,
    MenuItems: [
      {
        key: 'vouchers',
        name: 'Cadastro de Vouchers',
        component: () => <VouchersRegistration />,
        title: 'Cadastro de Vouchers',
        permissionName: PermissionNames.Offers.MenuVouchers,
      },
      {
        key: 'volLkp',
        name: 'Cadastro de Ofertas',
        component: () => <VolLkp />,
        title: 'Cadastro de Ofertas',
        permissionName: PermissionNames.Offers.MenuVolLkp,
        cantClose: true,
        onCloseAction: () => {
          const state: any = store.getState();
          const disabledSaveVol = state.core.volOffers.disabledSave;
          const disabledSaveLkp = state.core.lkpOffers.disabledSave;

          if (!disabledSaveVol) {
            store.dispatch(actions.ui.volOfferList.setConfirmSave(true));
            store.dispatch(actions.ui.volOfferList.setWaitEditOpen('waitingCloseTab'));

            return;
          }
          if (!disabledSaveLkp) {
            store.dispatch(actions.ui.lkpOfferList.setConfirmSaveLkp(true));
            store.dispatch(actions.ui.volOfferList.setWaitEditOpen('waitingCloseTab'));

            return;
          }
          store.dispatch(deleteTab('volLkp'));
        },
      },
    ],
  },
  {
    key: 'marketing-management',
    icon: <SolutionOutlined />,
    title: 'Gestão de Marketing',
    permissionName: PermissionNames.MarketingManagement.MenuMarketingManagement,
    MenuItems: [
      {
        key: 'registerAnnouncement',
        name: 'Cadastro de Comunicados',
        component: () => <RegisterAnnoucement />,
        title: 'Cadastro de Comunicados',
        permissionName: PermissionNames.MarketingManagement.MenuRegisterAnnouncement,
      },
    ],
  },
  {
    key: 'producerManagement',
    icon: <AreaChartOutlined />,
    title: 'Gestão do Produtor',
    permissionName: PermissionNames.ProducerManagement.MenuProducerManagement,
    MenuItems: [
      {
        key: 'producerPageManagement',
        name: 'Página do Produtor',
        component: () => <ProducerPageManagement />,
        title: 'Página do Produtor',
        permissionName: PermissionNames.ProducerManagement.MenuProducerPageManagement,
      },
    ],
  },
  {
    key: 'reports',
    icon: <AreaChartOutlined />,
    title: 'Relatórios',
    permissionName: PermissionNames.Reports.MenuReports,
    MenuItems: [
      {
        key: 'offer-report',
        name: 'Relatório de Vendas',
        component: () => <SalesReport />,
        title: 'Relatório de Vendas',
        permissionName: PermissionNames.Reports.MenuOfferReport,
      },
      {
        key: 'offer-report-ecommerce',
        name: 'Relatório de Vendas E-commerce',
        component: () => <SalesReportEcommerce />,
        title: 'Relatório de Vendas E-commerce',
        permissionName: PermissionNames.Reports.MenuOfferReportEcommerce,
      },
      {
        key: 'announcementReports',
        name: 'Relatório de Comunicados',
        component: () => <AnnouncementReport />,
        title: 'Relatório de Comunicados',
        permissionName: PermissionNames.Reports.MenuAnnouncementReports,
      },
      {
        key: 'price-report',
        name: 'Relatório de Preços',
        component: () => <PriceReport />,
        title: 'Relatório de Preços',
        permissionName: PermissionNames.Reports.MenuPriceReport,
      },
      {
        key: 'klok-draw-report',
        name: 'Relatório de Sorteio KLOK',
        component: () => <KlokDrawReport />,
        title: 'Relatório de Sorteio KLOK',
        permissionName: PermissionNames.Reports.MenuKlokDrawReport,
      },
      {
        key: 'klok-stock-report',
        name: 'Relatório de Estoque KLOK',
        component: () => <KlokStockReport />,
        title: 'Relatório de Estoque KLOK',
        permissionName: PermissionNames.Reports.MenuDetailedStock,
      },
      {
        key: 'agreement-report',
        name: 'Acordos e Termos Aditivos',
        component: () => <Agreements />,
        title: 'Acordos e Termos Aditivos',
        permissionName: PermissionNames.Reports.MenuAgreement,
      },
      {
        key: 'product-catalog',
        name: 'Catálogo de Produtos',
        component: () => <ProductCatalog />,
        title: 'Catalogo de Produtos',
        permissionName: PermissionNames.Reports.MenuProductCatalog,
      },
      {
        key: 'customer-catalog',
        name: 'Catálogo de Clientes',
        component: () => <CustomerCatalog />,
        title: 'Catálogo de Clientes',
        permissionName: PermissionNames.Reports.MenuCustomerCatalog,
      },
      {
        key: 'sales-statement',
        name: 'Extrato de Vendas',
        component: () => <SalesStatementByType />,
        title: 'Extrato de Vendas',
        permissionName: PermissionNames.Reports.MenuSalesStatement,
      },
    ],
  },
  {
    key: 'orders',
    icon: <OrderedListOutlined />,
    title: 'Pedidos',
    permissionName: PermissionNames.Orders.MenuOrders,
    MenuItems: [
      {
        key: 'order',
        name: 'Visualizar Pedidos',
        component: () => <Orders />,
        title: 'Visualizar Pedidos',
        permissionName: PermissionNames.Orders.MenuOrder,
      },
      {
        key: 'ordergfp',
        name: 'Pedidos x GFP',
        component: () => <OrdersGfp />,
        title: 'Pedidos x GFP',
        permissionName: PermissionNames.Orders.MenuOrdersGfp,
      },
      {
        key: 'ordersToCollect',
        name: 'Pedidos para Colher',
        component: () => <OrdersToCollect />,
        title: 'Pedidos para Colher',
        permissionName: PermissionNames.Orders.MenuOrdersToCollect,
      },
      {
        key: 'tagPrintingList',
        name: 'Lista de Impressão Etiquetas',
        component: () => <TagPrintingList />,
        title: 'Lista de Impressão Etiquetas',
        permissionName: PermissionNames.Orders.MenuTagPrintingList,
      },
      {
        key: 'klokReservation',
        name: 'Reserva Klok',
        component: () => <KlokReservation />,
        title: 'Reserva Klok',
        permissionName: PermissionNames.Orders.MenuKlokReservation,
      },
    ],
  },
  {
    key: 'indicatorsPanel',
    icon: <LineChartOutlined />,
    title: 'Painel de Indicadores',
    permissionName: PermissionNames.MenuIndicatorsPanel,
    MenuItems: [],
  },
  {
    key: 'rfid',
    icon: <ClusterOutlined />,
    title: 'Relatorios RFID',
    permissionName: PermissionNames.RfidReports.MenuRfidReports,
    MenuItems: [
      {
        key: 'inventory',
        name: 'Inventário',
        icon: <ClusterOutlined />,
        title: 'Inventário',
        permissionName: PermissionNames.RfidReports.MenuInventory,
        component: () => <Inventory />,
      },
      {
        key: 'receipt',
        name: 'Recebimento',
        icon: <ClusterOutlined />,
        title: 'Recebimento',
        permissionName: PermissionNames.RfidReports.MenuReceipt,
        component: () => <Receipt />,
      },
      {
        key: 'expeditionRfid',
        name: 'Expedição',
        icon: <ClusterOutlined />,
        title: 'Expedição',
        permissionName: PermissionNames.RfidReports.MenuExpedition,
        component: () => <ExpeditionReport />,
      },
      {
        key: 'movement',
        name: 'Transferência',
        icon: <ClusterOutlined />,
        title: 'Transferência',
        permissionName: PermissionNames.RfidReports.MenuMovement,
        component: () => <Movement />,
      },
    ],
  },
];
export default menus;
